<p-progressBar *ngIf="isLoadingBar"
               mode="indeterminate"
               [style]="{ height: '4px' }"></p-progressBar>
